import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { XCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { StatusBadge } from "../components/StatusBadge";
import { api } from "../lib/api";
export function UserHistory() {
    const [calls, setCalls] = useState([]);
    const [cancellingId, setCancellingId] = useState("");
    async function refresh() {
        const result = await api.userCalls();
        setCalls(result.calls);
    }
    useEffect(() => {
        refresh();
        const timer = window.setInterval(refresh, 3000);
        return () => window.clearInterval(timer);
    }, []);
    async function cancelCall(id) {
        setCancellingId(id);
        try {
            await api.cancelCall(id);
            await refresh();
        }
        finally {
            setCancellingId("");
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "head", children: _jsxs("div", { children: [_jsx("span", { className: "eyebrow", children: "History" }), _jsx("h1", { children: "\u8BF7\u6C42\u8BB0\u5F55" }), _jsx("p", { children: "\u8FD9\u91CC\u663E\u793A\u4F60\u7684\u6280\u672F\u652F\u6301\u8BF7\u6C42\u53CA\u5904\u7406\u72B6\u6001\u3002" })] }) }), _jsx("section", { className: "card table-card", children: _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "\u65F6\u95F4" }), _jsx("th", { children: "\u522B\u79F0" }), _jsx("th", { children: "\u9636\u6BB5" }), _jsx("th", { children: "\u6B21\u6570" }), _jsx("th", { children: "\u72B6\u6001" }), _jsx("th", { children: "\u64CD\u4F5C" })] }) }), _jsx("tbody", { children: calls.map((call) => (_jsxs("tr", { children: [_jsx("td", { children: new Date(call.createdAt).toLocaleString() }), _jsx("td", { children: call.alias }), _jsx("td", { children: call.phase === "PRIMARY" ? "主号码" : "备用号码" }), _jsx("td", { children: call.attempt }), _jsx("td", { children: _jsx(StatusBadge, { status: call.status }) }), _jsx("td", { children: call.status === "PENDING" ? (_jsxs("button", { type: "button", className: "btn secondary sm", onClick: () => cancelCall(call.id), disabled: cancellingId === call.id, children: [_jsx(XCircle, { size: 13 }), cancellingId === call.id ? "取消中" : "取消"] })) : (_jsx("span", { className: "muted", children: "-" })) })] }, call.id))) })] }) })] }));
}
